import { combineEpics } from "redux-observable";
import { of } from "rxjs";
import AnalysisResourceV2 from "@ane/exp-data/lib/resources/expapiv2/Analysis.resource";
import { produceLoadLoadingLoadedEpic } from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import AnalysisTaskConstants from "../ducks/AnalysisTaskConstants.js";
import { resubmittingTask, resubmittedTask, cancellingTask, cancelledTask } from "../ducks/AnalysisTaskActions.js";
const resubmitTaskEpic = produceLoadLoadingLoadedEpic({
  filterOnType: AnalysisTaskConstants.RESUBMIT_TASK,
  loadResource: (payload) => AnalysisResourceV2.resubmitScorecard(payload.WorkspaceId, payload.ScorecardId),
  loadingAction: (payload) => resubmittingTask(),
  loadedAction: (successData, payload, error) => {
    return of(resubmittedTask());
  }
});
const cancelTaskEpic = produceLoadLoadingLoadedEpic({
  filterOnType: AnalysisTaskConstants.CANCEL_TASK,
  loadResource: (payload) => AnalysisResourceV2.cancelScorecard(payload.WorkspaceId, payload.ScorecardId),
  loadingAction: (payload) => cancellingTask(),
  loadedAction: (successData, payload, error) => {
    return of(cancelledTask());
  }
});
const provideAnalysisTaskEpics = () => {
  const analysisTaskEpics = combineEpics(resubmitTaskEpic, cancelTaskEpic);
  return analysisTaskEpics;
};
export {
  cancelTaskEpic,
  provideAnalysisTaskEpics,
  resubmitTaskEpic
};
//# sourceMappingURL=AnalysisTaskEpic.js.map
